<script setup>
import {ref, nextTick} from 'vue'
import CustomMask from "@/components/NewPC/CustomMask.vue";
import {getOrderDetail, payOrder} from '@/api/common'
import {throttle} from '@/utils/utils'
import {showToast} from "vant";
import zfbLogo from '@/assets/newPc/topup/zfb.png'
import useAccount from '@/store/account'
import {useTgaStore} from "@/store/tga";
const tga = useTgaStore()
const accountStore = useAccount();
const CustomMaskRef = ref(null)
const payList = ref([])
const detail = ref(null)
const orderNotExist = ref(false)
const showPayTips = ref(false)
const payType = ref('alipay')
const CardCanvasRef = ref(null);
import QRCode from 'qrcode'

const open = (orderNo, account) => {
  if (!orderNo) {
    CustomMaskRef.value?.open()
    return
  }
  getOrderDetail({
    id: orderNo,
    account: account,
  }).then((res) => {
    if (res.status == 200 && res.data && res.data.code == 0) {
      detail.value = res.data.data;
      payList.value = detail.value.payType
      console.log('detail.value:', detail.value);
      CustomMaskRef.value?.open()
      handleConfirm();

      // 用户存在，上报
      tga.tgaTrack('web_campaigns_event', {
        web_campaigns_op: 'pc_page_exposure',
        account: detail.value.account.account,
        gps1: detail.value.account.invite_code,
        gps2: "确认订单页"
      })

    } else {
      orderNotExist.value = true;
    }
  })
}

// 确认支付
const handleConfirm = throttle(() => {
  if (!payType.value) {
    showToast('请选择支付方式')
    return
  }
  payOrder({
    orderNo: detail.value.order[0].pay_order,
    accountId: detail.value.account.invite_code,
    payType: payType.value,
    openid: '',
  }).then(res => {
    if (res.status == 200 && res.data.code == 0) {
      if (payType.value === 'alipay') {
        handleShowQrcode(`${window.location.origin}/m/ali-pay-link?orderNo=${detail.value.order[0].pay_order}`)
      }
    } else {
      showToast(res.data.msg)
    }
  })
}, 500)

const handleShowQrcode = link => {
  console.log('handleShowQrcode:', link);
  nextTick(() => {
    if (CardCanvasRef.value) {
      QRCode.toCanvas(CardCanvasRef.value, link, {
        width: 120,
        height: 120,
      }, function (error) {
        if (error) console.error(error);
      });

      // 2. 在二维码中心绘制 Logo
      const ctx = CardCanvasRef.value.getContext('2d');
      const logo = new Image();
      logo.src = zfbLogo; // 替换为你的 Logo 图片 URL
      logo.onload = () => {
        const logoSize = 20; // Logo 的大小
        const x = (CardCanvasRef.value.width - logoSize) / 2; // 计算 Logo 的 X 坐标
        const y = (CardCanvasRef.value.height - logoSize) / 2; // 计算 Logo 的 Y 坐标
        // 绘制 Logo 到二维码中心
        ctx.drawImage(logo, x, y, logoSize, logoSize);
      };
    }
  })
}
const handleRefresh = () => {
  getOrderDetail({
    id: detail.value.order[0].pay_order,
    account: detail.value.account.invite_code,
  }).then(res => {
    if (res.status == 200 && res.data && res.data.code == 0) {
      detail.value = res.data.data;
      showPayTips.value = true;
      if (detail.value.order[0].pay_state == 'approved') {
        tga.tgaTrack('web_campaigns_event', {
          web_campaigns_op: 'pc_page_exposure',
          account: detail.value && detail.value.account && detail.value.account.account ? detail.value.account.account:'未绑定',
          gps1: detail.value && detail.value.invite_code && detail.value.account.invite_code ? detail.value.account.invite_code:null,
          gps2: "支付成功页"
        })
      }

    }
  })
}
defineExpose({open})
</script>

<template>
  <custom-mask ref="CustomMaskRef">
    <div class="order_dialog_content" v-if="detail">
      <img class="order_dialog_close" src="@/assets/newPc/topup/order_dialog_close.png" @click="CustomMaskRef.open()" alt="">
      <template  v-for="item of detail.order">
        <div class="title">商品内容：{{ item.name }}</div>
        <div class="detail">
          <div>商品订单：{{ item.pay_order }}</div>
          <div>收获信息：{{ detail.account.nickname }} </div>
          <div>账号ID： {{  detail.account.invite_code }}</div>
          <div>发货方式：购买后，登录游戏立即获得</div>
        </div>
      </template>
      <div class="error_tips">
        <span v-if="showPayTips">{{ detail.order[0].pay_state == 'approved' ? '':'支付未成功，请您再次尝试一下' }}</span>
      </div>
      <div class="qrcode">
        <canvas v-if="detail.order[0].pay_state != 'approved'" class="qrcode" ref="CardCanvasRef"></canvas>
      </div>
      <div class="tips" v-if="detail.order[0].pay_state != 'approved'">支付宝扫一扫，立即支付</div>
      <div class="footer">
        <template  v-if="detail.order[0].pay_state != 'approved'">
          <button @click="CustomMaskRef.open()">取消支付</button>
          <button class="confirm" @click="handleRefresh">支付完成</button>
        </template>
        <button v-else class="confirm">支付成功</button>
      </div>
      <div v-if="detail.order[0].pay_state == 'approved'" class="success_tips">祝您游戏愉快！</div>
    </div>
  </custom-mask>
</template>
<style lang='scss' scoped>
@import url('@/style/fonts.scss');
.order_dialog_content {
  width: 20.43478260869565vw;
  background: transparent url('@/assets/newPc/topup/order_dialog_bg.png') no-repeat center center;
  background-size: cover;
  position: relative;
  padding: 2.578125vw 1.171875vw 1.5625vw;
  box-sizing: border-box;
  border-radius: 0.78125vw;

  .order_dialog_close {
    position: absolute;
    top: 0.8203125vw;
    right: 0.8203125vw;
    width: 1.5625vw;
    height: 1.5625vw;
    cursor: pointer;
  }

  .title {
    margin-bottom: 0.8984375vw;
    color: #FF9120;
    font-family: 'SourceHanSansCN-Bold';
    font-size: 1.09375vw;
  }

  .detail {
    width: 100%;
    height: 6.2109375vw;
    padding: 0.8203125vw;
    color: #6B6660;
    font-size: 0.78125vw;
    font-family: 'SourceHanSansCN-Medium';
    background-color: #fff;
    box-sizing: border-box;
    margin-bottom: 0.8203125vw;
  }

  .error_tips {
    text-align: center;
    color: #FF0000;
    font-family: 'SourceHanSansCN-Medium';
    font-size: 0.859375vw;
    line-height: 1;
    margin-bottom: 0.390625vw;
  }

  .qrcode {
    width: 120px;
    height: 120px;
    margin: auto;
  }

  .tips {
    margin-top: 0.5078125vw;
    color: #FF9120;
    font-family: 'SourceHanSansCN-Medium';
    font-size: 0.859375vw;
    text-align: center;
    margin-bottom: 1.015625vw;
    padding: 0;
  }

  .footer {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    margin-top: 0.8203125vw;
    button {
      width: 8.4765625vw;
      height: 2.265625vw;
      line-height: 2.265625vw;
      border: none;
      padding: 0;
      margin: 0;
      background-color: #6B6660;
      color: #fff;
      border-radius: 1.1328125vw;
      cursor: pointer;
      margin-right: 0.8203125vw;
      &.confirm {
        background-color: #FF9F1D;
        margin-right: 0;
      }
    }
  }

  .success_tips {
    margin-top: 0.5859375vw;
    text-align: center;
    color: #FF9120;
    font-family: 'SourceHanSansCN-Medium';
    font-size: 0.859375vw;
  }

}

</style>
